var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar"}},[_c('navbar-top'),(!_vm.storeMode || _vm.isDiamondsPage)?_c('navbar-bottom'):_vm._e(),_c('navbar-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }